var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSysaidCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.7286H13L8.54999 21.8234C7.88999 22.2835 7 21.792 7 20.9556V18.7286C4 18.7286 2 16.6375 2 13.5009V7.22769C2 4.09108 4 2 7 2H17C20 2 22 4.09108 22 7.22769V13.5009C22 16.6375 20 18.7286 17 18.7286Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1773 5.34001C12.1097 5.17779 11.8903 5.17779 11.8227 5.34002L7.11273 16.6348C6.98419 16.9431 6.64184 17.0836 6.34805 16.9488C6.05426 16.8139 5.9203 16.4547 6.04883 16.1465L10.7588 4.85168C11.2323 3.71611 12.7677 3.71611 13.2412 4.85168L17.9512 16.1465C18.0797 16.4547 17.9457 16.8139 17.6519 16.9488C17.3582 17.0836 17.0158 16.9431 16.8873 16.6348L12.1773 5.34001Z",
    fill: "#7D899D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2,
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSysaidCommunity);
export default __webpack_public_path__ + "static/media/sysaid_community.1801fd3ed77761ca26f25730daf0190d.svg";
export { ForwardRef as ReactComponent };